import { Injectable, inject } from '@angular/core';
import { ApiService } from '../../core/services/api.service';
import { Observable } from 'rxjs';
import { ApiResponse, Staff } from '../models';

@Injectable({ providedIn: 'root' })
export class StaffService {
    private api = inject(ApiService);
    private readonly path = 'staff';

    getAll(params?: any): Observable<ApiResponse<Staff[]>> {
        return this.api.get<ApiResponse<Staff[]>>(this.path, params);
    }

    getById(id: string): Observable<ApiResponse<Staff>> {
        return this.api.get<ApiResponse<Staff>>(`${this.path}/${id}`);
    }

    getByBusiness(business: string): Observable<ApiResponse<Staff[]>> {
        return this.api.get<ApiResponse<Staff[]>>(this.path, { business });
    }

    getSearch(search: string): Observable<ApiResponse<Staff[]>> {
        return this.api.get<ApiResponse<Staff[]>>(this.path, { search });
    }

    create(data: {
        user: string;
        business: string;
        permissions?: string[];
    }): Observable<ApiResponse<Staff>> {
        return this.api.post<ApiResponse<Staff>>(this.path, data);
    }

    invite(data: {
        email: string;
        fullName?: string;
        password?: string;
        permissions: string[];
        business?: string;
        isOdontologist?: boolean;
    }): Observable<any> {
        return this.api.post<any>(`${this.path}/invite`, data);
    }

    update(id: string, data: {
        permissions?: string[];
        isActive?: boolean;
        isOdontologist?: boolean;
    }): Observable<any> {
        return this.api.put<any>(`${this.path}/${id}`, data);
    }

    delete(id: string): Observable<any> {
        return this.api.delete<any>(`${this.path}/${id}`);
    }
}
